import { cplatGPTApi } from '@/api';
import { AxiosError } from 'axios';

export interface ChatbotRequest {
  seller_id: string;
  input_text: string;
  user_action?: string | null;
  platform?: 'APP' | 'WEB';
  session_id?: string;
  guid?: string;
}

export interface ChatbotResponseItem {
  session_id: string;
  response: string;
  max_question_count?: number;
  question_remain_count?: number;
}

export interface ChatbotResponse {
  code: number;
  message: string;
  data: ChatbotResponseItem[];
}

export const queryChatbotAPI = async (
  data: ChatbotRequest,
  signal?: AbortSignal,
): Promise<ChatbotResponseItem> => {
  try {
    const response = await cplatGPTApi.post<ChatbotResponse>('/sellerboxSqlAgent/chat', data, {
      signal,
    });

    if (
      !response.data ||
      !response.data.data ||
      response.data.data.length === 0 ||
      response.data.code !== 200
    ) {
      throw {
        code: response.data.code ?? 500,
        message: response.data.message || '알 수 없는 오류',
      };
    }

    return response.data.data[0];
  } catch (error: unknown) {
    console.error('AI 챗봇 응답 오류:', error);

    let errorResponse = {
      code: 500,
      message: 'AI 응답을 가져오는 중 오류가 발생했습니다.',
    };

    // AxiosError 인 경우
    if (error instanceof AxiosError) {
      errorResponse = {
        code: error.response?.data?.code ?? 500,
        message: error.response?.data?.message || 'AI 응답을 가져오는 중 오류가 발생했습니다.',
      };
    }
    // 이미 { code, message } 형태로 throw 된 경우
    else if (typeof error === 'object' && error !== null && 'code' in error && 'message' in error) {
      errorResponse = {
        code: (error as { code: number }).code,
        message: (error as { message: string }).message,
      };
    }
    // 일반적인 JavaScript Error 처리
    else if (error instanceof Error) {
      errorResponse = {
        code: 1234,
        message: '',
      };
    }

    throw errorResponse;
  }
};
